export default __webpack_public_path__ + "68f0e181f3c57d89ace9d1d9bcc5ec20.png";